import React from 'react';
import { CardDefault, Text } from '@spark';
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip } from 'recharts';
import { buildPieSlicePercentLabel } from '@/shared/utils/pieChartUtils';

// Matches `.spark-card-default .spark-card-slot { min-height: 307px }` so the
// card keeps the same height when `fullWidth` disables Spark's min-heights.
const CARD_SLOT_MIN_HEIGHT = 307;

const OverviewPieChart = ({
    titleMain,
    titleSub,
    data,
    width = 185,
    height = 185,
    outerRadius = 74,
    fullWidth = false,
}) => {
    const renderCustomizedLabel = buildPieSlicePercentLabel(
        data.map(d => (typeof d.value === 'number' ? d.value : 0)),
        { fill: 'white', fontSize: 10 },
    );

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload;
            return (
                <div style={{
                    backgroundColor: '#060606',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '8px',
                    color: 'white',
                }}>
                    <p style={{ margin: '0 0 4px 0', fontWeight: 'bold' }}>{item.name}</p>
                    {Array.isArray(item.tooltipLines) && item.tooltipLines.length > 0 ? (
                        item.tooltipLines.map((line, idx) => (
                            <p key={idx} style={{ margin: '0 0 4px 0' }}>{line}</p>
                        ))
                    ) : (
                        <p style={{ margin: '0 0 4px 0' }}>{item.tooltipText}</p>
                    )}
                </div>
            );
        }
        return null;
    };

    return (
        <CardDefault
            title={`${titleMain} ${titleSub}`}
            showSubtitle={false}
            border="yes"
            fullWidth={fullWidth}
        >
            <div style={{ minHeight: CARD_SLOT_MIN_HEIGHT, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ width, height, margin: '0 auto' }}>
                    <PieChart width={width} height={height}>
                        <RechartsTooltip content={<CustomTooltip />} />
                        <Pie
                            data={data}
                            cx={width / 2}
                            cy={height / 2}
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={outerRadius}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                    </PieChart>
                </div>
            </div>
        </CardDefault>
    );
};

export default OverviewPieChart;
